export default "__VITE_ASSET__d$S7wUxP__"